import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            studentIds: [],
            total: 0,
            actions: [
                'Add to Course',
                'Add to Event',
                'Add to Team',
                'Archive',
                'Reset Tokens'
            ],
            bulkAction: '',
            loading: false,
            showBulkAction: false,
            selectedBulkAction: ''
        }
    },
    computed: {
        ...mapState({
            bulkStudents: ({ studentList }) => studentList.bulkStudents
        }),
        bulkDisable() {
            if (
                this.bulkStudents.length == 0 ||
                this.bulkAction == '' ||
                this.loading == true
            ) {
                return true
            }
            else {
                return false
            }
        }
    },
    beforeDestroy() {
        this.resetBulkActions()
    },
    methods: {
        ...mapActions([
            'addCourseToStudents',
            'addStudentsToEvent',
            'addStudentsToTeam',
            'removeStudents',
            'resetStudentsTokens'
        ]),
        bulkRefresh() { },
        performBulkAction() {
            switch (this.bulkAction) {
            case 'Add to Course':
                this.selectedBulkAction = 'course-picker'
                this.showBulkAction = true
                break
            case 'Add to Event':
                this.selectedBulkAction = 'event-picker'
                this.showBulkAction = true
                break
            case 'Add to Team':
                this.selectedBulkAction = 'team-picker'
                this.showBulkAction = true
                break
            case 'Archive':
                this.$confirm({
                    title: 'Confirm',
                    message: 'Are you sure you want to archive these students?'
                })
                    .then(() => {
                        this.loading = true
                        return this.removeStudents()
                    })
                    .then(() => {
                        this.loading = false
                        this.notifySuccess('The students were archived successfully')
                        this.bulkRefresh()
                        this.resetBulkActions()
                    })

                break
            case 'Reset Tokens':
                this.$confirm({
                    title: 'Confirm',
                    message: 'Are you sure you reset these students\' tokens?'
                })
                    .then(() => {
                        this.loading = true
                        return this.resetStudentsTokens()
                    })
                    .then(() => {
                        this.loading = false
                        this.notifySuccess('The students\' tokens were reset successfully')
                        this.resetBulkActions()
                    })
                break
            }
        },
        addBulkToSelection({ id }) {
            this.$confirm({
                title: 'Confirm',
                message: 'Are you sure you want to proceed with this action?'
            }).then(() => {
                switch (this.bulkAction) {
                case 'Add to Course':
                    this.loading = true
                    this.addCourseToStudents(id).then(() => {
                        this.loading = false
                        this.notifySuccess('The students were added to the course successfully')
                        this.resetBulkActions()
                    })
                    break
                case 'Add to Event':
                    this.loading = true
                    this.addStudentsToEvent(id).then(() => {
                        this.loading = false
                        this.notifySuccess('The students were added to the event successfully')
                        this.resetBulkActions()
                    })
                    break
                case 'Add to Team':
                    this.loading = true
                    this.addStudentsToTeam(id).then(() => {
                        this.loading = false
                        this.notifySuccess('The students were added to the team successfully')
                        this.resetBulkActions()
                    })
                    break
                }
            })
        },
        resetBulkActions() {
            this.showAddStudent = false
            this.showBulkAction = false
            this.selectedBulkAction = ''
            this.$store.commit('BULK_STUDENT_LIST_CLEAR')
        },
        notifySuccess(message) {
            this.$notify({
                title: 'Success',
                message: message,
                type: 'success',
                offset: 75,
                duration: 5000
            })
        }
    }
}